import { FC } from "react";

interface BreadCrumbsArrowSVGProps {
    className?: string;
}

const BreadCrumbsArrowSVG: FC<BreadCrumbsArrowSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 1L6.85858 6.85858C6.93668 6.93668 6.93668 7.06332 6.85858 7.14142L1 13"
                stroke="currentColor"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default BreadCrumbsArrowSVG;
